module.exports = __webpack_public_path__ + "img/microsoft.377f34e7.png";